export default __webpack_public_path__ + "static/media/reply.d5e1dbe1.svg";